<!--
 * @Author: yuanjianlong
 * @Description:
 * @Date: 2021-11-29 17:03:15
 * @LastEditTime: 2022-01-07 14:17:24
 * @FilePath: /teacher-h5/src/demo/index.vue
-->
<template>
  <div class="page-demo">
    <div>
      <a-menu
        class="com-menu"
        mode="inline"
        v-model="selectedKeys"
        :open-keys.sync="openKeys"
      >
        <a-sub-menu key="sub1">
          <span slot="title">
            <i class="iconfont icon-list" />
            <span>组件列表</span>
          </span>
          <a-menu-item v-for="(item, index) in list" :key="index">
            <router-link :to="{name: item.name}">
              {{ item.title }}
            </router-link>
          </a-menu-item>
        </a-sub-menu>
      </a-menu>
    </div>
    <div class="page-demo-right">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      openKeys: ['sub1'],
      list: [
        {
          title: 'Button 按钮',
          name: 'button'
        },
        {
          title: 'Input 输入框',
          name: 'input'
        },
        {
          title: 'Form 表单',
          name: 'form'
        },
        {
          title: 'Checkbox 多选框',
          name: 'checkbox'
        },
        {
          title: 'Radio 单选框',
          name: 'radio'
        },
        {
          title: 'Modal 对话框',
          name: 'modal'
        },
        {
          title: 'Message 全局提示',
          name: 'message'
        },
        {
          title: 'Pagination 分页',
          name: 'pagination'
        },
        {
          title: 'Switch 开关',
          name: 'switch'
        },
        {
          title: 'Breadcrumb 面包屑',
          name: 'breadcrumb'
        },
        {
          title: '语音点评',
          name: 'audio'
        },
        {
          title: '答案',
          name: 'answer'
        },
        {
          title: '视频',
          name: 'video'
        },
        {
          title: '课件',
          name: 'courseware'
        },
        {
          title: 'icons',
          name: 'icons'
        },
        {
          title: '高频互动',
          name: 'gaopin'
        }
      ],
      selectedKeys: []
    }
  },
  mounted() {
    const routerName = this.$route.name
    const index = this.list.findIndex(item => item.name === routerName)
    this.selectedKeys = [index]
  }
}
</script>

<style lang="less" scoped>
@import '~@/static/css/base.less';

.page-demo {
  display: flex;
  height: 100%;
}
.com-menu {
  width: 208px;
  height: 100%;
  background-color: @gray-10;
}

.page-demo-right {
  padding: 20px;
  flex: 1 1 auto;
  background-color: @gray-10;
  overflow-y: auto;
}
</style>